// React Dependencies
import React, { useCallback, useEffect, useRef, useState } from "react"
import { useLocation } from "react-router"

// External Dependencies
import { useTranslation } from "react-i18next"
import { format } from "date-fns"
import { Card } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { DateRange } from "react-date-range"

// Internal Dependencies
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { CardBody, CardHeader } from "../../../../_metronic/_partials/controls/index.js"
import Summary from "./Summary.jsx"
import { Table } from "./table/Table.jsx"
import { FilterCard, LocationMolecule, SelectInput } from "../../../../component/index.jsx"
import { initialFilterTable } from "../../../../component/atoms/Tabel/index.jsx"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { CalenderSvgIcon } from "../../../../component/atoms/Icons/SVG/calender.jsx"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { DATE_TYPE_ENUM } from "../../../../constants/StringConstant.js"
import { dateSelect } from "../../../helpers/DateHelper.js"
import { useUrlParam } from "../../../hooks/useUrlParams.jsx"
import { getMitraFilterPlantingSeason } from "../../../../redux/actions/MitraAction.jsx"
import { getListRegionalSelected, getPlantType } from "../../../../redux/actions/MasterDataAction.jsx"
import { getListReadyPlantingSeasonConfirmation } from "../../../../redux/actions/AreaAction.jsx"

export const ListReadyPlantingSeasonConfirmation = ({
  history,
  match: {
    params: { tab }
  }
}) => {
  const subHeader = useSubheader()
  const formRef = useRef()
  const { t } = useTranslation()
  const { General, Area, Mitra, MasterData } = useSelector((state) => state)
  const urlParams = useUrlParam()
  const location = useLocation()
  const dispatch = useDispatch()
  const userLogin = JSON.parse(localStorage.getItem("userLogin"))

  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const [searchValue, setSearchValue] = useState("")
  const [resetLocation, setResetLocation] = useState(false)
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [isActiveFilter, setIsActiveFilter] = useState(false)
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [btnFilterDisable, setBtnFilterDisable] = useState(true)
  const [initialValue, setInitialValue] = useState({
    ...initialFilterTable,
    tab: tab,
    province_id: "",
    regency_id: "",
    district_id: "",
    sub_district_id: "",
    mitra_id: "",
    plant_type_id: "",
    harvest_start_date: "",
    harvest_end_date: ""
  })

  const [openDate, setOpenDate] = useState(false)
  const [dateRange, setDateRange] = useState("")
  const [state, setState] = useState([
    {
      startDate: "",
      endDate: "",
      key: "selection"
    }
  ])

  const [mitraList, setMitraList] = useState([])
  const [mitraFilterValue, setMitraFilterValue] = useState("")
  const [selectedRegional, setSelectedRegional] = useState([])
  const [listRegional, setListRegional] = useState([])
  const [selectedRegionalUser, setSelectedRegionalUser] = useState()
  const [plantType, setPlantType] = useState([])
  const [plantTypeValue, setPlantTypeValue] = useState("")

  useEffect(() => {
    subHeader.setTitle(t(`label_ready_planting_season_confirmation`))
    subHeader.setButton(null)
    dispatch(getMitraFilterPlantingSeason())
    dispatch(getListRegionalSelected())
    dispatch(getPlantType())
    if (userLogin?.regional_id) {
      setSelectedRegionalUser(userLogin?.regional_id)
    }
  }, [])

  useEffect(() => {
    setQueryStringObj(urlParams.getUrlParamsObj)
  }, [urlParams.getUrlParamsObj])

  useEffect(() => {
    if (Mitra?.data) {
      setMitraList(
        Mitra.data.map((value) => ({
          label: value?.name,
          value: value?.id
        }))
      )
    }
  }, [Mitra.data])

  useEffect(() => {
    if (MasterData?.listRegionalSelected) {
      setListRegional(
        MasterData.listRegionalSelected.map((item) => ({
          label: item?.name + " (" + item?.code + ")",
          value: item?.id
        }))
      )
    }
  }, [MasterData])

  useEffect(() => {
    if (MasterData?.plantType) {
      setPlantType(
        MasterData.plantType.map((value) => ({
          label: value?.name,
          value: value?.id
        }))
      )
    }
  }, [MasterData?.plantType])

  useEffect(() => {
    if (listRegional && selectedRegionalUser) {
      const data = listRegional.find((e) => e?.value === selectedRegionalUser)
      if (data) {
        setSelectedRegional([data])
      }
    }
  }, [listRegional, selectedRegionalUser])

  useEffect(() => {
    if (formRef.current?.values?.province_id || mitraFilterValue || plantTypeValue || dateRange)
      setBtnFilterDisable(false)
    else setBtnFilterDisable(true)
  }, [mitraFilterValue, plantTypeValue, dateRange, formRef.current?.values])

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearchValue(queryStringObj.keyword)
      setIsActiveSearch(true)
    } else {
      setSearchValue("")
      setIsActiveSearch(false)
    }

    if (
      queryStringObj?.plant_type_id ||
      queryStringObj?.mitra_id ||
      queryStringObj?.province_id ||
      queryStringObj?.regency_id ||
      queryStringObj?.district_id ||
      queryStringObj?.sub_district_id ||
      queryStringObj?.harvest_start_date ||
      queryStringObj?.harvest_end_date
    ) {
      setIsActiveFilter(true)
      const data = {
        ...initialFilterTable,
        tab: tab,
        keyword: queryStringObj?.keyword,
        plant_type_id: queryStringObj?.plant_type_id || "",
        mitra_id: queryStringObj?.mitra_id || "",
        province_id: queryStringObj?.province_id || "",
        regency_id: queryStringObj?.regency_id || "",
        district_id: queryStringObj?.district_id || "",
        sub_district_id: queryStringObj?.sub_district_id || "",
        harvest_start_date: queryStringObj?.harvest_start_date || "",
        harvest_end_date: queryStringObj?.harvest_end_date || ""
      }

      setInitialValue(data)
      setMitraFilterValue(queryStringObj?.mitra_id || "")
      setPlantTypeValue(queryStringObj?.plant_type_id || "")

      if (data?.harvest_start_date && data?.harvest_end_date) {
        let selectedDate =
          dateSelect(format(new Date(data.harvest_start_date), DATE_TYPE_ENUM.ISO_DATE_EURO)) +
          " s/d " +
          dateSelect(format(new Date(data.harvest_end_date), DATE_TYPE_ENUM.ISO_DATE_EURO))
        setDateRange(selectedDate)
        setState([
          {
            startDate: new Date(data.harvest_start_date),
            endDate: new Date(data.harvest_end_date),
            key: "selection"
          }
        ])
      } else {
        setDateRange("")
        setState([
          {
            startDate: "",
            endDate: "",
            key: "selection"
          }
        ])
      }
    } else {
      setIsActiveFilter(false)
      setMitraFilterValue("")
      setPlantTypeValue("")
      setDateRange("")
      setState([
        {
          startDate: "",
          endDate: "",
          key: "selection"
        }
      ])
    }
  }, [queryStringObj])

  useEffect(() => {
    const result = location?.search
    fetchData(result)
  }, [location.search])

  function fetchData(param) {
    dispatch(getListReadyPlantingSeasonConfirmation(param))
  }

  const changePage = useCallback(
    (param) => {
      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...initialValue,
          ...param,
          tab: tab,
          sort: param?.sortField ? param.sortField + "," + param.sortOrder : "",
          keyword: searchValue
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...initialValue,
          ...param,
          tab: tab,
          keyword: searchValue
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [searchValue, initialValue, location]
  )

  const onSearch = (values) => {
    setSearchValue(values?.keyword)
    setIsActiveSearch(true)
    let param = {
      ...initialValue,
      tab: tab,
      keyword: values?.keyword
    }
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const handleResetSearch = () => {
    setSearchValue("")
    setIsActiveSearch(false)
    const param = {
      ...initialValue,
      tab: tab,
      keyword: ""
    }
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const handleOpenCloseFilter = (value) => {
    setIsShowFilter(value)
  }

  const onSubmitFilter = (e) => {
    setResetLocation(false)
    const valueArray = 0
    const { values, submited } = e
    if (submited) {
      setIsActiveFilter(true)
      setIsShowFilter(false)
      const paramData = {
        ...initialFilterTable,
        tab: tab,
        keyword: searchValue,
        mitra_id: values?.mitra_id || "",
        province_id: values?.province_id || "",
        regency_id: values?.regency_id || "",
        district_id: values?.district_id || "",
        sub_district_id: values?.sub_district_id || "",
        plant_type_id: values?.plant_type_id || "",
        harvest_start_date: state[valueArray].startDate
          ? format(state[valueArray].startDate, DATE_TYPE_ENUM.ISO_DATE_EURO)
          : "",
        harvest_end_date: state[valueArray].endDate
          ? format(state[valueArray].endDate, DATE_TYPE_ENUM.ISO_DATE_EURO)
          : ""
      }
      if (paramData) {
        setInitialValue(paramData)
        const urlParam = getUrlParsingPageFilter(paramData)
        history.push({ pathname: location.pathname, search: urlParam })
      }
    }
  }

  const onResetFilter = () => {
    setDateRange("")
    setResetLocation(true)
    setIsShowFilter(false)
    setIsActiveFilter(false)
    setMitraFilterValue("")
    setPlantTypeValue("")
    setState([
      {
        startDate: "",
        endDate: "",
        key: "selection"
      }
    ])
    const param = {
      ...initialFilterTable,
      tab: tab,
      keyword: searchValue,
      province_id: "",
      regency_id: "",
      district_id: "",
      sub_district_id: "",
      mitra_id: "",
      plant_type_id: "",
      harvest_start_date: "",
      harvest_end_date: ""
    }
    setInitialValue(param)
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  // Date picker handlers
  const submitLog = () => {
    const valueArray = 0
    let selectedDate =
      dateSelect(format(state[valueArray]?.startDate, DATE_TYPE_ENUM.ISO_DATE_EURO)) +
      " s/d " +
      dateSelect(format(state[valueArray]?.endDate, DATE_TYPE_ENUM.ISO_DATE_EURO))
    setDateRange(selectedDate)
    setOpenDate(false)
  }

  const resetDate = () => {
    setOpenDate(false)
    setDateRange("")
    setState([
      {
        startDate: "",
        endDate: "",
        key: "selection"
      }
    ])
  }

  function dateRangePicker() {
    return (
      <div style={{ transform: `translateY(23px)` }}>
        <div className={"date-picker-custom "} style={{ fontSize: 11 }}>
          <DateRange
            className={"font-10"}
            onChange={(item) => setState([item.selection])}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={1}
            ranges={state}
            direction="horizontal"
            preventSnapRefocus={true}
            calendarFocus="backwards"
          />
          <div className={"action-wrapper d-flex justify-content-end py-4 px-4 border-top"}>
            <button onClick={resetDate} type={"button"} className={"btn btn-outline-primary mx-4"}>
              {t("label_reset")}
            </button>
            <button onClick={submitLog} type={"button"} className={"btn btn-primary mx-4"}>
              {t("label_apply")}
            </button>
          </div>
        </div>
      </div>
    )
  }

  function selectDate() {
    return (
      <div className={"mt-5"}>
        <div className={"d-flex justify-content-end"}>
          <div
            onClick={() => setOpenDate(!openDate)}
            className={
              "select-date d-flex justify-content-between align-items-center cursor-pointer"
            }>
            <label className={"mb-0 txt-12 cursor-pointer"}>
              {dateRange ? dateRange : t("placeholder_select_date_range")}
            </label>
            <CalenderSvgIcon />
          </div>
        </div>
      </div>
    )
  }

  function checkRegionalSelected() {
    if (userLogin?.regional_id) {
      return userLogin?.regional_id
    } else {
      if (selectedRegional) {
        const data = selectedRegional.map((e) => {
          return e.value
        })
        if (data.length > 0) {
          return data.join(",")
        }
      }
    }
  }

  const checkFilterAndSearch = () => {
    if (isActiveSearch || isActiveFilter) {
      return true
    } else {
      return false
    }
  }

  const filterComponent = (
    <>
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_mitra")} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <SelectInput
              name="mitra_id"
              label={t("label_mitra_name")}
              editable={true}
              placeholder={t("placeholder_select_one")}
              options={mitraList}
              withoutFeedback={true}
              isClearable={true}
              value={mitraFilterValue}
              onChange={(e) => setMitraFilterValue(e)}
            />
          </RowModule>
        </CardBody>
      </Card>
      <LocationMolecule
        resetLocation={resetLocation}
        regionalId={checkRegionalSelected()}
        name="filter"
        withoutFeedback={true}
        isReadOnly={false}
        addressTitle={t("label_location")}
        removeHorizontalPadding={true}
      />
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_plant")} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <SelectInput
              name="plant_type_id"
              onChange={(e) => setPlantTypeValue(e)}
              editable={true}
              label={t("label_plant_type")}
              placeholder={t("placeholder_select_one")}
              options={plantType}
              withoutFeedback={true}
              clearNow={true}
              value={plantTypeValue}
              isClearable={true}
            />
          </RowModule>
        </CardBody>
      </Card>
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_harvest_date")} className={"px-0"} />
        {selectDate()}
        {openDate && dateRangePicker()}
      </Card>
    </>
  )

  return (
    <div className={"d-flex flex-column"}>
      <FilterCard
        isActiveSearch={isActiveSearch}
        placeholder={t("placeholder_insert_area_name_or_farmer")}
        onSubmitForm={onSearch}
        initialValues={{ keyword: searchValue }}
        name={"keyword"}
        innerRef={formRef}
        trigerReset={handleResetSearch}
        filterInnerRef={formRef}
        filterHandleSubmit={onSubmitFilter}
        filterFormInitialValues={initialValue}
        filterComponent={filterComponent}
        filterOnReset={onResetFilter}
        showFilter={isShowFilter}
        handleOpenCloseFilter={handleOpenCloseFilter}
        filterOn={isActiveFilter}
        btnDisable={btnFilterDisable}
      />
      <Summary />
      <Table
        data={Area}
        changePage={changePage}
        history={history}
        general={General}
        isActiveSearch={isActiveSearch}
        initialFilterTable={initialFilterTable}
        isFilter={checkFilterAndSearch()}
        fetchData={fetchData}
        tab={tab ?? 0}
        urlParams={urlParams}
      />
    </div>
  )
}